import { getTranslationID } from "translation";

export const COUNTRY_LIST = [
  { disabled: true, value: "Africa", label: "Africa" },
  { disabled: false, value: "DZ", label: "Algeria" },
  { disabled: false, value: "AO", label: "Angola" },
  { disabled: false, value: "BJ", label: "Benin" },
  { disabled: false, value: "BW", label: "Botswana" },
  { disabled: false, value: "BF", label: "Burkina Faso" },
  { disabled: false, value: "BI", label: "Burundi" },
  { disabled: false, value: "CM", label: "Cameroon" },
  { disabled: false, value: "CF", label: "Central African Republic" },
  { disabled: false, value: "TD", label: "Chad" },
  { disabled: false, value: "CG", label: "Congo" },
  { disabled: false, value: "CI", label: "Cote d'Ivoire" },
  { disabled: false, value: "DJ", label: "Djibouti" },
  { disabled: false, value: "EG", label: "Egypt" },
  { disabled: false, value: "ET", label: "Ethiopia" },
  { disabled: false, value: "GA", label: "Gabon" },
  { disabled: false, value: "GM", label: "Gambia" },
  { disabled: false, value: "GH", label: "Ghana" },
  { disabled: false, value: "GN", label: "Guinea" },
  { disabled: false, value: "GY", label: "Guyana" },
  { disabled: false, value: "KE", label: "Kenya" },
  { disabled: false, value: "LR", label: "Liberia" },
  { disabled: false, value: "LY", label: "Libya" },
  { disabled: false, value: "MG", label: "Madagascar" },
  { disabled: false, value: "ML", label: "Mali" },
  { disabled: false, value: "MR", label: "Mauritania" },
  { disabled: false, value: "MUS", label: "Mauritius" },
  { disabled: false, value: "MA", label: "Morocco" },
  { disabled: false, value: "MZ", label: "Mozambique" },
  { disabled: false, value: "NA", label: "Namibia" },
  { disabled: false, value: "NE", label: "Niger" },
  { disabled: false, value: "NG", label: "Nigeria" },
  { disabled: false, value: "RW", label: "Rwanda" },
  { disabled: false, value: "SN", label: "Senegal" },
  { disabled: false, value: "SL", label: "Sierra Leone" },
  { disabled: false, value: "SO", label: "Somalia" },
  { disabled: false, value: "ZA", label: "South Africa" },
  { disabled: false, value: "SD", label: "Sudan" },
  { disabled: false, value: "TZ", label: "Tanzania" },
  { disabled: false, value: "TG", label: "Togo" },
  { disabled: false, value: "TN", label: "Tunisia" },
  { disabled: false, value: "UG", label: "Uganda" },
  { disabled: false, value: "ZM", label: "Zambia" },
  { disabled: false, value: "ZW", label: "Zimbabwe" },
  { disabled: true, value: "Americas", label: "Americas" },
  { disabled: false, value: "AR", label: "Argentina" },
  { disabled: false, value: "BS", label: "Bahamas" },
  { disabled: false, value: "BB", label: "Barbados" },
  { disabled: false, value: "BZ", label: "Belize" },
  { disabled: false, value: "BO", label: "Bolivia" },
  { disabled: false, value: "BR", label: "Brazil" },
  { disabled: false, value: "CA", label: "Canada" },
  { disabled: false, value: "CL", label: "Chile" },
  { disabled: false, value: "CO", label: "Colombia" },
  { disabled: false, value: "DO", label: "Dominican Republic" },
  { disabled: false, value: "EC", label: "Ecuador" },
  { disabled: false, value: "SV", label: "El Salvador" },
  { disabled: false, value: "GF", label: "French Guiana" },
  { disabled: false, value: "GT", label: "Guatemala" },
  { disabled: false, value: "GY", label: "Guyana" },
  { disabled: false, value: "HT", label: "Haiti" },
  { disabled: false, value: "HN", label: "Honduras" },
  { disabled: false, value: "JM", label: "Jamaica" },
  { disabled: false, value: "MX", label: "Mexico" },
  { disabled: false, value: "NI", label: "Nicaragua" },
  { disabled: false, value: "PY", label: "Paraguay" },
  { disabled: false, value: "PE", label: "Peru" },
  { disabled: false, value: "PR", label: "Puerto Rico" },
  { disabled: false, value: "LC", label: "Saint Lucia" },
  { disabled: false, value: "SR", label: "Suriname" },
  { disabled: false, value: "TT", label: "Trinidad and Tobago" },
  { disabled: false, value: "US", label: "U.S.A" },
  { disabled: false, value: "UY", label: "Uruguay" },
  { disabled: true, value: "Asia", label: "Asia" },
  { disabled: false, value: "BD", label: "Bangladesh" },
  { disabled: false, value: "CN", label: "China" },
  { disabled: false, value: "HK", label: "Hong Kong" },
  { disabled: false, value: "IN", label: "India" },
  { disabled: false, value: "ID", label: "Indonesia" },
  { disabled: false, value: "JP", label: "Japan" },
  { disabled: false, value: "KR", label: "Korea" },
  { disabled: false, value: "MY", label: "Malaysia" },
  { disabled: false, value: "PH", label: "Philippines" },
  { disabled: false, value: "SG", label: "Singapore" },
  { disabled: false, value: "TW", label: "Taiwan" },
  { disabled: false, value: "TH", label: "Thailand" },
  { disabled: false, value: "VN", label: "Vietnam" },
  { disabled: true, value: "Europe", label: "Europe" },
  { disabled: false, value: "AL", label: "Albania" },
  { disabled: false, value: "IC", label: "Andorra" },
  { disabled: false, value: "AT", label: "Austria" },
  { disabled: false, value: "BY", label: "Belarus" },
  { disabled: false, value: "BE", label: "Belgium" },
  { disabled: false, value: "BA", label: "Bosnia and Herzegovina" },
  { disabled: false, value: "BG", label: "Bulgaria" },
  { disabled: false, value: "HR", label: "Croatia" },
  { disabled: false, value: "CZ", label: "Czech Republic" },
  { disabled: false, value: "DK", label: "Denmark" },
  { disabled: false, value: "EE", label: "Estonia" },
  { disabled: false, value: "FO", label: "Faroe Islands" },
  { disabled: false, value: "FI", label: "Finland" },
  { disabled: false, value: "FR", label: "France" },
  { disabled: false, value: "GE", label: "Georgia" },
  { disabled: false, value: "DE", label: "Germany" },
  { disabled: false, value: "GR", label: "Greece" },
  { disabled: false, value: "GL", label: "Greenland " },
  { disabled: false, value: "HU", label: "Hungary" },
  { disabled: false, value: "IS", label: "Iceland" },
  { disabled: false, value: "IE", label: "Ireland" },
  { disabled: false, value: "IT", label: "Italy" },
  { disabled: false, value: "KZ", label: "Kazakhstan" },
  { disabled: false, value: "LV", label: "Latvia" },
  { disabled: false, value: "LT", label: "Lithuania" },
  { disabled: false, value: "LU", label: "Luxembourg" },
  { disabled: false, value: "MK", label: "Macedonia" },
  { disabled: false, value: "MT", label: "Malta" },
  { disabled: false, value: "MD", label: "Moldova " },
  { disabled: false, value: "ME", label: "Montenegro" },
  { disabled: false, value: "NL", label: "Netherlands" },
  { disabled: false, value: "NC", label: "New Caledonia" },
  { disabled: false, value: "NO", label: "Norway" },
  { disabled: false, value: "PL", label: "Poland" },
  { disabled: false, value: "PT", label: "Portugal" },
  { disabled: false, value: "RO", label: "Romania" },
  { disabled: false, value: "RU", label: "Russia" },
  { disabled: false, value: "RS", label: "Serbia" },
  { disabled: false, value: "SK", label: "Slovakia " },
  { disabled: false, value: "SI", label: "Slovenia" },
  { disabled: false, value: "ES", label: "Spain" },
  { disabled: false, value: "SE", label: "Sweden" },
  { disabled: false, value: "CH", label: "Switzerland" },
  { disabled: false, value: "TR", label: "Turkey" },
  { disabled: false, value: "TM", label: "Turkmenistan" },
  { disabled: false, value: "UA", label: "Ukraine" },
  { disabled: false, value: "GB", label: "U.K." },
  { disabled: false, value: "UZ", label: "Uzbekistan" },
  { disabled: true, value: "Middle East", label: "Middle East" },
  { disabled: false, value: "AF", label: "Afghanistan" },
  { disabled: false, value: "AM", label: "Armenia" },
  { disabled: false, value: "AZ", label: "Azerbaijan" },
  { disabled: false, value: "BH", label: "Bahrain" },
  { disabled: false, value: "CY", label: "Cyprus" },
  { disabled: false, value: "AE-DU", label: "Dubai" },
  { disabled: false, value: "IR", label: "Iran" },
  { disabled: false, value: "IQ", label: "Iraq" },
  { disabled: false, value: "IL", label: "Israel" },
  { disabled: false, value: "JO", label: "Jordan" },
  { disabled: false, value: "KW", label: "Kuwait" },
  { disabled: false, value: "KG", label: "Kyrgyzstan" },
  { disabled: false, value: "LB", label: "Lebanon" },
  { disabled: false, value: "OM", label: "Oman" },
  { disabled: false, value: "PS", label: "Palestine" },
  { disabled: false, value: "QA", label: "Qatar" },
  { disabled: false, value: "SA", label: "Saudi Arabia" },
  { disabled: false, value: "SY", label: "Syria" },
  { disabled: false, value: "TJ", label: "Tajikistan" },
  { disabled: false, value: "AE", label: "United Arab Emirates" },
  { disabled: false, value: "YE", label: "Yemen" },
  { disabled: true, value: "Oceania", label: "Oceania" },
  { disabled: false, value: "AU", label: "Australia" },
  { disabled: false, value: "NZ", label: "New Zealand" },
  { disabled: true, value: "CategoryOthers", label: "Others" },
  { disabled: false, value: "XX", label: "Others" },
];

export const JOB_TYPE_LIST = [
  {
    value: "ElectricDesign",
    label: getTranslationID("signupPage.label.jobTypeElectricDesign"),
  },
  {
    value: "MechanicalDesign",
    label: getTranslationID("signupPage.label.jobTypeMechanicalDesign"),
  },
  {
    value: "SoftwareDesign",
    label: getTranslationID("signupPage.label.jobTypeSoftwareDesign"),
  },
  {
    value: "ElectronicDesign",
    label: getTranslationID("signupPage.label.jobTypeElectronicDesign"),
  },
  {
    value: "SafetyAndHealth",
    label: getTranslationID("signupPage.label.jobTypeSafetyAndHealth"),
  },
  {
    value: "ProductionEngineering",
    label: getTranslationID("signupPage.label.jobTypeProductionEngineering"),
  },
  {
    value: "Maintenance",
    label: getTranslationID("signupPage.label.jobTypeMaintenance"),
  },
  {
    value: "Manufacturing",
    label: getTranslationID("signupPage.label.jobTypeManufacturing"),
  },
  {
    value: "ResearchAndDevelopment",
    label: getTranslationID("signupPage.label.jobTypeResearchAndDevelopment"),
  },
  {
    value: "QualityManagement",
    label: getTranslationID("signupPage.label.jobTypeQualityManagement"),
  },
  {
    value: "MaterialProcurement",
    label: getTranslationID("signupPage.label.jobTypeMaterialProcurement"),
  },
  {
    value: "ProductionAndInfo",
    label: getTranslationID("signupPage.label.jobTypeProductionAndInfo"),
  },
  {
    value: "SalesAndMarketing",
    label: getTranslationID("signupPage.label.jobTypeSalesAndMarketing"),
  },
  {
    value: "MaintenanceService",
    label: getTranslationID("signupPage.label.jobTypeMaintenanceService"),
  },
  {
    value: "ProductPlanning",
    label: getTranslationID("signupPage.label.jobTypeProductPlanning"),
  },
  {
    value: "BusinessManagement",
    label: getTranslationID("signupPage.label.jobTypeBusinessManagement"),
  },
  { value: "Other", label: getTranslationID("signupPage.label.jobTypeOther") },
];

export const PREFECTURE_LIST = [
  { value: "北海道", label: "北海道" },
  { value: "青森県", label: "青森県" },
  { value: "岩手県", label: "岩手県" },
  { value: "宮城県", label: "宮城県" },
  { value: "秋田県", label: "秋田県" },
  { value: "山形県", label: "山形県" },
  { value: "福島県", label: "福島県" },
  { value: "茨城県", label: "茨城県" },
  { value: "栃木県", label: "栃木県" },
  { value: "群馬県", label: "群馬県" },
  { value: "埼玉県", label: "埼玉県" },
  { value: "千葉県", label: "千葉県" },
  { value: "東京都", label: "東京都" },
  { value: "神奈川県", label: "神奈川県" },
  { value: "新潟県", label: "新潟県" },
  { value: "富山県", label: "富山県" },
  { value: "石川県", label: "石川県" },
  { value: "福井県", label: "福井県" },
  { value: "山梨県", label: "山梨県" },
  { value: "長野県", label: "長野県" },
  { value: "岐阜県", label: "岐阜県" },
  { value: "静岡県", label: "静岡県" },
  { value: "愛知県", label: "愛知県" },
  { value: "三重県", label: "三重県" },
  { value: "滋賀県", label: "滋賀県" },
  { value: "京都府", label: "京都府" },
  { value: "大阪府", label: "大阪府" },
  { value: "兵庫県", label: "兵庫県" },
  { value: "奈良県", label: "奈良県" },
  { value: "和歌山県", label: "和歌山県" },
  { value: "鳥取県", label: "鳥取県" },
  { value: "島根県", label: "島根県" },
  { value: "岡山県", label: "岡山県" },
  { value: "広島県", label: "広島県" },
  { value: "山口県", label: "山口県" },
  { value: "徳島県", label: "徳島県" },
  { value: "香川県", label: "香川県" },
  { value: "愛媛県", label: "愛媛県" },
  { value: "高知県", label: "高知県" },
  { value: "福岡県", label: "福岡県" },
  { value: "佐賀県", label: "佐賀県" },
  { value: "長崎県", label: "長崎県" },
  { value: "熊本県", label: "熊本県" },
  { value: "大分県", label: "大分県" },
  { value: "宮崎県", label: "宮崎県" },
  { value: "鹿児島県", label: "鹿児島県" },
  { value: "沖縄県", label: "沖縄県" },
];
